import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import { PLANT_OVERVIEW_COUNTRIES } from '@common';
import { BookingStore } from '@store';

@Component({
  selector: 'app-commercial-subscription-summary',
  templateUrl: './commercial-subscription-summary.component.html',
  styleUrls: ['./commercial-subscription-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialSubscriptionSummaryComponent {
  bookingPlans = SubscriptionPlan;
  overviewUrl = 'https://heating-systems-overview.viessmann-climatesolutions.com/welcome';
  plantOverviewCountries = PLANT_OVERVIEW_COUNTRIES;

  constructor(public bookingStore: BookingStore) {}
}
